export const PROFILE_ROUTE_NAMES = {
    PROFILE: "ProfilePage",
    EDIT: "ProfileEdit",
};
